import React from "react";
import { Redirect, Route, Switch } from "react-router";
import "./App.scss";
import CurrencyInfo from "./components/CurrencyInfo/CurrencyInfo";
import Header from "./components/Header/Header";
import Main from "./components/Main/Main";

const App = () => {
  return (
    <div className="App">
      <Header />
      <Switch>
        <Route path="/main/:currentPage?" render={() => <Main />} />
        <Route path="/currency/:currencyId?" render={() => <CurrencyInfo />} />
        <Route path="/" render={() => <Redirect to="/main/1" />} />
      </Switch>
    </div>
  );
};

export default App;
